import { Icon } from '@chakra-ui/react';

export const ViewsIcon = (props: any) => (
  <Icon aria-label="views icon" viewBox="4 4 16 16" {...props}>
    <path
      d="m6.42217836 18h11.15567474c1.5693039 0 2.4221469-.7947033 2.4221469-2.2410645v-7.51788072c0-1.44635473-.852843-2.24105478-2.4221469-2.24105478h-11.15567474c-1.56076252 0-2.42217836.79470005-2.42217836 2.24105478v7.51788072c0 1.4463612.86141584 2.2410645 2.42217836 2.2410645zm.2046956-1.7245046c-.50320639 0-.77612804-.2304692-.77612804-.7311198v-7.08874464c0-.50066689.27292165-.73112795.77612804-.73112795h10.74628354c.5032064 0 .776128.23046106.776128.73112795v7.08874464c0 .5006506-.2729216.7311198-.776128.7311198zm3.3262381-2.2569478c0 .3019756.36673684.4529796.67377154.2860907l3.6247314-1.9629228c.2729216-.1509878.2729216-.5244942 0-.6754983l-3.6247314-1.97084896c-.2985108-.15894652-.67377154-.00795872-.67377154.29403316z"
      fill="currentColor"
    />
  </Icon>
);
